import React from "react";
import styled from "styled-components";
import level1Svg from "assets/icons/proficiency-level-1.svg";
import level2Svg from "assets/icons/proficiency-level-2.svg";
import level3Svg from "assets/icons/proficiency-level-3.svg";

const BADGE_SVGS = {
  1: level1Svg,
  2: level2Svg,
  3: level3Svg,
};

export const ProficiencyLevelBadge = ({ level, color, size = 80, fontSize }) => {
  const src = BADGE_SVGS[level] || BADGE_SVGS[1];
  const numberFontSize = fontSize ?? Math.round(size * 0.4);
  const offset = Math.max(2, Math.round((size * 5) / 80));
  const padding = Math.max(1, Math.round((size * 4) / 80));

  return (
    <BadgeContainer $size={size}>
      <BadgeImg src={src} alt={`Level ${level}`} $size={size} />
      <LevelNumber
        $color={color}
        $fontSize={numberFontSize}
        $offset={offset}
        $padding={padding}
      >
        {level}
      </LevelNumber>
    </BadgeContainer>
  );
};

const BadgeContainer = styled.div`
  position: relative;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BadgeImg = styled.img`
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
`;

const LevelNumber = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - ${(p) => p.$offset}px));
  padding-top: ${(p) => p.$padding}px;
  font-family: "ABC Marfa", sans-serif;
  font-weight: 600;
  font-size: ${(p) => p.$fontSize}px;
  line-height: ${(p) => Math.max(12, Math.round(p.$fontSize * 0.75))}px;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  text-align: center;
  color: ${(p) => p.$color};
`;
